export const truncatePriceTo2Decimals = (price: number) => {
  const re = new RegExp('^-?\\d+(?:\\.\\d{0,' + 2 + '})?');
  const truncated = (price.toString().match(re) || ['0'])[0];
  const [intPart, decimalPart] = truncated.split('.');

  // Agregar separadores de miles
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
};
